// client/src/pages/Feedback.js
import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function Feedback() {
  const { user } = useAuth();

  const [rating, setRating] = useState(0);
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return alert("Please write your feedback!");

    setLoading(true);

    try {
      const body = {
        rating,
        message,
        name: user ? user.name : "Guest User",
        email: user ? user.email : "guest@collegepal.com",
        userId: user ? user.id : null,
      };

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Feedback submission failed");
        setLoading(false);
        return;
      }

      setSubmitted(true);
    } catch (err) {
      console.error(err);
      alert("Server error");
    }

    setLoading(false);
  };

  // SUCCESS MESSAGE
  if (submitted) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50 dark:bg-slate-900 px-4">
        <div className="bg-white dark:bg-slate-800 p-10 rounded-2xl shadow-xl text-center max-w-md">
          <h2 className="text-3xl font-bold text-green-600 dark:text-green-400">
            Thank You!
          </h2>
          <p className="text-slate-600 dark:text-slate-300 mt-3 text-lg">
            Your feedback helps us grow.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900 px-6 py-12">
      <div className="max-w-xl mx-auto">

        {/* HEADER */}
        <div className="text-center mb-8">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-indigo-600 dark:text-indigo-400">
            Share Your Feedback
          </h1>

          <p className="mt-3 text-slate-600 dark:text-slate-300 text-lg">
            Help us shape the future of CollegePal.
          </p>
        </div>

        {/* CARD */}
        <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 shadow-xl rounded-2xl p-8 backdrop-blur">

          <form onSubmit={handleSubmit} className="space-y-6">

            {/* NAME */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-slate-200 mb-1">
                Name
              </label>

              <input
                type="text"
                value={user ? user.name : ""}
                placeholder="Enter your name"
                readOnly={!!user}
                className="w-full rounded-lg p-3 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-slate-900 dark:text-white"
              />
            </div>

            {/* EMAIL */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-slate-200 mb-1">
                Email
              </label>

              <input
                type="email"
                value={user ? user.email : ""}
                placeholder="Enter your email"
                readOnly={!!user}
                className="w-full rounded-lg p-3 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-slate-900 dark:text-white"
              />
            </div>

            {/* RATING */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-slate-200 mb-2">
                Rate Your Experience
              </label>

              <div className="flex justify-center space-x-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    onClick={() => setRating(star)}
                    className={`text-4xl cursor-pointer transition transform hover:scale-110 ${
                      rating >= star
                        ? "text-yellow-400 drop-shadow-sm"
                        : "text-slate-300 dark:text-slate-600"
                    }`}
                  >
                    ★
                  </span>
                ))}
              </div>
            </div>

            {/* MESSAGE */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 dark:text-slate-200 mb-1">
                Your Feedback
              </label>

              <textarea
                rows="5"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Tell us what you think..."
                className="w-full p-3 rounded-lg bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-slate-900 dark:text-white resize-none"
              ></textarea>
            </div>

            {/* SUBMIT */}
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 rounded-lg text-white text-lg font-semibold transition shadow-md ${
                loading
                  ? "bg-slate-400 cursor-not-allowed"
                  : "bg-indigo-600 hover:bg-indigo-700"
              }`}
            >
              {loading ? "Submitting..." : "Submit Feedback"}
            </button>
          </form>

        </div>
      </div>
    </div>
  );
}
